import React from "react"
// material-ui
import MUIAvatar from "material-ui/Avatar"


const rightAligned = {
    position: "absolute",
    right: 15,
    top: 15
}

const Avatar = ({
    person = {},
    right = false,
    size = 75
}) =>
    <MUIAvatar
        src={ (person.has("photo") && person.get("photo") !== "") ?
            person.get("photo")
            : null }
        style={ right ? rightAligned : null }
        size={ size }
    >
    { (!person.has("photo") || person.get("photo") === "") ?
        person.get("firstname").substring(0, 1) +
        person.get("lastname").substring(0, 1)
        :
        null
    }
    </MUIAvatar>

export default Avatar


/** WEBPACK FOOTER **
 ** ./src/components/person/Avatar/avatar.js
 **/